/* eslint-disable no-dupe-keys */
import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const UnusualDataCard = () => {

  const options = {
    chart: {
      type: 'line',
      height: 60,
      width: 120,
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    series: [
      {
        name: 'Trend',
        data: [10, 0, 12, 6, 12, 0, 14, 7, 2],
        color: '#ff3b30', // Red line color
        lineWidth: 2,
        marker: {
          enabled: false,
        },
      },
    ],
    credits: {
      enabled: false,
    },
  };
  const activityData = [
    {
      title: 'Members',
      number: '45'
    },
    {
      title: 'Instances',
      number: '25'
    },
    {
      title: 'Total Time',
      number: '25:34:12'
    },
    {
      title: 'Avg Confidence',
      statusBtn: 'High',
      // avgGraph: <HighchartsReact highcharts={Highcharts} options={options} />
    },
  ]
  return (
    <>
      <Box sx={{ backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #DFDFDF', borderRadius: '8px' }}>
        <Grid container spacing={2}>
          {
            activityData.map((item, index) => (
              <Grid size={{ xs: 6, md: 3, lg: 3, xl: 3, sm: 3 }}>
                <div className="card-body border-end-0 d-flex flex-column justify-content-center my-20 mx-25"
                  style={{
                   
                    // lineHeight: index === 3 ? '3px' : 'initial', height: index === 3 ? '48px' : 'initial',
                    paddingLeft: '25px',
                    borderLeft: index === 0 ? 'none' : '1px solid #ddd'
                  }}>
                  <div>
                    <div>
                      <span className="fw-medium text-secondary-light text-sm" style={{ fontFamily: 'Manrope' }}>{item.title}</span>
                      {
                        item.number && (
                          <Typography className="text-primary-light" style={{ fontSize: '21px', fontWeight: '500', color: '#373737', fontFamily: 'Manrope' }}>{item.number}</Typography>
                        )
                      }
                      <Box display="flex" alignContent="center" justifyContent="space-between" alignItems="center">
                        {
                          item.statusBtn && (
                            <Typography style={{ fontFamily: 'Manrope', fontSize: '16px', fontWeight: '600', color: '#F4413D', backgroundColor: '#F4413D1A', height: '34px', padding: '6px 20px', borderRadius: '100px', textAlign: 'center', width: '76px' }}>{item.statusBtn}</Typography>
                          )
                        }
                        {
                          item.avgGraph && (
                            <Box>{item.avgGraph}</Box>
                          )
                        }
                      </Box>
                    </div>
                  </div>
                </div>
              </Grid>
            ))
          }
        </Grid>
      </Box>
    </>

  );
};

export default UnusualDataCard;
